/* Canonical public site URL + referral attribution persistence (iter101).

   1. PUBLIC_SITE_URL — every shareable/copyable link (referral links, QR
      posters) must encode the permanent production domain, never a
      preview host. Mirrors backend site_url.canonical_base().

   2. Referral persistence — partner referral codes arriving on ANY page
      (?ref= / ?partner= / ?partner_code= and MP ?invite=) are stored for
      30 days so attribution survives refreshes, navigation, and multi-
      page browsing before signup. Last-touch wins: a newly clicked
      partner link overwrites an older stored code. */

export const PUBLIC_SITE_URL = 'https://myleaflegacy.com';

const REF_KEY = 'myleaf_ref';
const INVITE_KEY = 'myleaf_mp_invite';
const TTL_MS = 30 * 24 * 3600 * 1000;

const sanitize = (v) => (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

function store(key, code) {
  try {
    localStorage.setItem(key, JSON.stringify({ code, at: Date.now() }));
  } catch { /* private mode — session-only attribution still works via URL */ }
}

function read(key) {
  try {
    const raw = JSON.parse(localStorage.getItem(key) || 'null');
    if (!raw?.code) return '';
    if (Date.now() - (raw.at || 0) > TTL_MS) {
      localStorage.removeItem(key);
      return '';
    }
    return sanitize(raw.code);
  } catch {
    return '';
  }
}

export function captureReferralParams(search) {
  const sp = new URLSearchParams(search || '');
  const ref = sanitize(sp.get('ref') || sp.get('partner') || sp.get('partner_code'));
  if (ref) store(REF_KEY, ref);
  const invite = sanitize(sp.get('invite'));
  if (invite) store(INVITE_KEY, invite);
}

export const getStoredReferralCode = () => read(REF_KEY);
export const getStoredInviteCode = () => read(INVITE_KEY);

export function clearStoredReferral() {
  try {
    localStorage.removeItem(REF_KEY);
    localStorage.removeItem(INVITE_KEY);
  } catch { /* noop */ }
}
